import { ComponentType, createElement } from 'react';
import { createRoot } from 'react-dom/client';

import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './constants.ts';
import { svgToPng } from './svgToPng.ts';

export const pngChartMaker = async <T extends object>(
  element: ComponentType<T>,
  props: T,
): Promise<string | undefined> => {
  const tmp = document.createElement('div');
  tmp.style.width = `${PNG_WIDTH * IMAGE_FACTOR}px`;
  tmp.style.height = `${PNG_HEIGHT * IMAGE_FACTOR}px`;
  tmp.style.position = 'absolute';
  tmp.style.left = '-9999px';
  document.body.appendChild(tmp);

  const root = createRoot(tmp);
  root.render(createElement(element, props));

  await new Promise((resolve) => {
    setTimeout(resolve, 50);
  });

  const svgs = Array.from(tmp.querySelectorAll<SVGSVGElement>('.recharts-surface'));
  const largestSvg = svgs.reduce((largest, svg) => {
    const area = svg.clientWidth * svg.clientHeight;
    return area > (largest?.clientWidth ?? 0) * (largest?.clientHeight ?? 0) ? svg : largest;
  }, svgs[0]);

  if (!largestSvg) {
    root.unmount();
    document.body.removeChild(tmp);
    return undefined;
  }

  const pngData = await svgToPng(largestSvg, PNG_WIDTH * IMAGE_FACTOR, PNG_HEIGHT * IMAGE_FACTOR);

  root.unmount();
  document.body.removeChild(tmp);
  return pngData;
};
